import { render, staticRenderFns } from "./penalty-parameters-form.vue?vue&type=template&id=2568ed19&scoped=true"
import script from "./penalty-parameters-form.vue?vue&type=script&lang=js"
export * from "./penalty-parameters-form.vue?vue&type=script&lang=js"
import style0 from "./penalty-parameters-form.vue?vue&type=style&index=0&id=2568ed19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2568ed19",
  null
  
)

export default component.exports